"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JslGridDisplay = void 0;
const lodash_1 = __importDefault(require("lodash"));
const GridDisplay_1 = require("./GridDisplay");
const CollectionGridDisplay_1 = require("./CollectionGridDisplay");
const dbgate_tools_1 = require("dbgate-tools");
class JslGridDisplay extends GridDisplay_1.GridDisplay {
    constructor(jslid, structure, config, setConfig, cache, setCache, rows, isDynamicStructure, supportsReload, editable = false, driver = null, currentSettings = null) {
        var _a;
        super(config, setConfig, cache, setCache, driver, undefined, undefined, currentSettings);
        this.filterable = true;
        this.sortable = true;
        this.supportsReload = supportsReload;
        this.isDynamicStructure = isDynamicStructure;
        this.filterBehaviourOverride = dbgate_tools_1.evalFilterBehaviour;
        this.editable = editable;
        this.editableStructure = editable ? structure : null;
        if (structure === null || structure === void 0 ? void 0 : structure.columns) {
            this.columns = lodash_1.default.uniqBy((_a = structure.columns
                .map(col => ({
                columnName: col.columnName,
                headerText: col.columnName,
                uniqueName: col.columnName,
                uniquePath: [col.columnName],
                notNull: col.notNull,
                autoIncrement: col.autoIncrement,
                pureName: null,
                schemaName: null,
            }))) === null || _a === void 0 ? void 0 : _a.map(col => (Object.assign(Object.assign({}, col), { isChecked: this.isColumnChecked(col) }))), col => col.uniqueName);
        }
        if (structure === null || structure === void 0 ? void 0 : structure.__isDynamicStructure) {
            this.columns = (0, CollectionGridDisplay_1.analyseCollectionDisplayColumns)(rows, this);
        }
        if (!this.columns)
            this.columns = [];
        this.formColumns = this.columns;
    }
}
exports.JslGridDisplay = JslGridDisplay;
